import { nuiCtx } from './initialization';
import { pathSubscription } from 'nike-re-framejs';

//TODO unify platform user model
export const firstName$ = () =>
    nuiCtx.platform === 'mobile'
        ? pathSubscription(['account', 'userData', 'userName'])
        : pathSubscription(['account', 'user', 'firstName']);

export const lastName$ = () =>
    nuiCtx.platform === 'mobile'
        ? pathSubscription(['account', 'userData', 'userSurname'])
        : pathSubscription(['account', 'user', 'lastName']);

export const email$ = () =>
    nuiCtx.platform === 'mobile'
        ? pathSubscription(['account', 'userData', 'email'])
        : pathSubscription(['account', 'user', 'contact', 'email']);

export const telephone$ = () =>
    nuiCtx.platform === 'mobile'
        ? pathSubscription(['account', 'userData', 'phone'])
        : pathSubscription(['account', 'user', 'contact', 'phone']);

export const contractNumber$ = () =>
    nuiCtx.platform === 'mobile'
        ? pathSubscription(['account', 'userData', 'cisloZmluvy'])
        : pathSubscription(['account', 'user', 'contractNumber']);

export const nickName$ = () =>
    nuiCtx.platform === 'mobile'
        ? pathSubscription(['account', 'userData', 'nickname'])
        : pathSubscription(['account', 'user', 'prezyvka']);

export const loggedIn$ = pathSubscription(['loggedIn'], false);
